import gql from 'graphql-tag';

export const GET_ALL_CURSOS = gql`
	query GetAllCursos {
		cursos {
			key
			nivel
			identificadorNivel
			year
			colegio {
				nombre
				key
			}
			estudiantes {
				key
			}
			ruta {
				key
				nombre
			}
		}
	}
`;

export const GET_CURSOS_BY_COLEGIO = gql`
	subscription GetCursosByColegio1($colegio_key: uuid!) {
		cursos(where: { colegio_key: { _eq: $colegio_key } }) {
			key
			nivel
			identificadorNivel
			colegio {
				nombre
				key
			}
			estudiantes {
				key
			}
			ruta {
				key
				nombre
			}
		}
	}
`;

export const GET_CURSO_BY_KEY = gql`
	subscription GetCursoByKey($curso_key: uuid!) {
		cursos(where: { key: { _eq: $curso_key } }) {
			key
			nivel
			identificadorNivel
			colegio {
				nombre
				key
			}
			ruta {
				sesiones
			}
			desafios_cursos {
				ruta {
					sesiones
				}
				desafios_cursos_estudiantes_grupos {
					grupo {
						key
						respuestas {
							key
							actividad {
								sesion {
									sesion_rutas {
										numeroSesion
									}
								}
							}
						}
					}
				}
				respuestas(where: { actividad: { tipo: { _eq: "individual" } } }) {
					key
					estudiante {
						key
					}
					actividad {
						sesion {
							sesion_rutas {
								numeroSesion
							}
						}
					}
				}
			}
			estudiantes {
				key
			}
		}
	}
`;

export const GET_CURSOS_BY_COLEGIO_AND_RUTAS = gql`
	subscription GetCursosByColegioAndRutas($colegio_key: uuid!, $year: Int!) {
		cursos(where: { colegio_key: { _eq: $colegio_key }, year: { _eq: $year } }) {
			key
			nivel
			year
			yearEnd
			identificadorNivel
			idioma
			ciclo
			identificador
			cursos_electivo_tramos {
				key
				curso_key
				tramo_curso_key
				tramo_curso {
					key
					nombre
					nivel
					pais
				}
			}
			desafios_cursos {
				key
				activo
				curso {
					nivel
					identificadorNivel
				}
				curso_key
				ruta {
					key
					nombre
					nombreDesafio
					from_year
					to_year
					creador_nombre
					numero_creacion
					periodo_academico
					colegio {
						tag_name
						nombre
					}
				}
			}
			colegio {
				nombre
				key
				pais
			}
			estudiantes {
				key
			}
			estudiante_cursos {
				estudiante {
					key
				}
			}
			ruta {
				key
				nombre
			}
		}
	}
`;

export const GET_CURSOS_ACTIVOS_BY_COLEGIO_AND_RUTAS = gql`
	query GetCursosActivosByColegioAndRutas($colegio_key: uuid!) {
		cursos(where: { colegio_key: { _eq: $colegio_key }, desafios_cursos: { activo: { _eq: true } } }) {
			key
			nivel
			year
			identificadorNivel
		}
	}
`;

export const GET_CURSOS_BY_COLEGIO_AND_RUTAS_BY_YEAR = gql`
	query GetCursosActivosByColegioAndRutas2($colegio_key: uuid!, $year: Int!) {
		cursos(where: { colegio_key: { _eq: $colegio_key }, year: { _gte: $year } }) {
			key
			nivel
			year
			identificadorNivel
		}
	}
`;

export const GET_CURSOS_BY_COLEGIO_AND_RUTAS_BY_YEAR_AND_YEAREND = gql`
	query GetCursosActivosByColegioAndRutas3($colegio_key: uuid!, $year: Int!, $yearEnd: Int!) {
		cursos(where: { colegio_key: { _eq: $colegio_key }, year: { _eq: $year }, yearEnd: { _eq: $yearEnd } }) {
			key
			nivel
			year
			identificadorNivel
		}
	}
`;

export const GET_SPECIFICY_DESAFIOS_CURSO_BY_DESAFIO_CURSO_KEY = gql`
	subscription GetCursosByColegioAndRutas2($desafioCursoKey: uuid!) {
		desafios_cursos(where: { key: { _eq: $desafioCursoKey } }) {
			key
			curso {
				nivel
				identificadorNivel
			}
			curso_key
			ruta {
				key
			}
		}
	}
`;

export const INSERT_RUTA_ASIGNATURA_HORARIO_MASIVO = gql`
	mutation insertRutaAsignaturaHorario($objects: [ruta_asignaturas_horario_insert_input!]!) {
		insert_ruta_asignaturas_horario(objects: $objects) {
			returning {
				key
			}
		}
	}
`;

export const GET_DATA_CALENDARIO_BY_RUTA_SPECIFIC = gql`
	query Data_Calendario_Profesor_by_desafiocursokey($rutaKey: uuid!) {
		ruta_asignaturas(where: { isDeleted: { _eq: false }, ruta_key: { _eq: $rutaKey } }) {
			key
			label
			value
			labelAbrev
			color
			isDeleted
		}
		desafios_cursos(where: { ruta_key: { _eq: $rutaKey }, activo: { _eq: true } }) {
			key
			curso_key
			curso {
				key
				nivel
				identificadorNivel
			}
		}
		ruta_asignaturas_horario(
			where: { ruta_key: { _eq: $rutaKey } }
			order_by: { diaSemana: asc, inicioHora: asc }
		) {
			key
			diaSemana
			inicioHora
			finHora
			curso_key
			detalle
			ruta_key
			curso {
				key
				identificadorNivel
				nivel
				year
			}
			horario_calendario_profesor {
				key
				fecha_inicio
				fecha_fin
				calendario_profesor_asignaturas {
					key
					ruta_asignatura {
						key
						label
						color
						labelAbrev
						asignaturaId
					}
				}
				calendario_profesor_cursos_lista {
					calendario_curso {
						key
						nivel
						year
						identificadorNivel
					}
				}
			}
			ruta_asignaturas_horario_lista {
				key
				ruta_asignaturas {
					key
					label
					color
					labelAbrev
				}
			}
			ruta_asignaturas_horario_cursos {
				key
				curso_key
				horario_cursos {
					key
					nivel
					identificadorNivel
				}
			}
		}
	}
`;

export const GET_MINIMAL_CURSO_BY_KEY = gql`
	query GetMinimalCursoByKey($key: uuid!) {
		cursos(where: { key: { _eq: $key } }) {
			key
			nivel
			identificadorNivel
			year
			yearEnd
		}
	}
`;

export const HISTORIAL_EDIT_CURSOS_BY_COLEGIO = gql`
	query HistorialEditEstudianteDataByCursos($colegio_key: uuid!) {
		logs_edited_cursos_data(where: { colegio_key: { _eq: $colegio_key } }, order_by: { fecha_edited: desc }) {
			key
			user_action
			type_user
			user_action_key
			curso_key
			fecha_edited
			colegio_key
			content_edited
			logs_edited_user_cuenta {
				key
				user {
					nombre
					apellido
				}
			}
		}
	}
`;

export const INSERT_LOGS_EDIT_CURSOS = gql`
	mutation InsertLogsEditCursos(
		$colegio_key: uuid!
		$curso_key: uuid!
		$user_action: String!
		$type_user: String!
		$user_action_key: uuid!
		$content_edited: jsonb!
	) {
		insert_logs_edited_cursos_data_one(
			object: {
				colegio_key: $colegio_key
				curso_key: $curso_key
				user_action: $user_action
				type_user: $type_user
				user_action_key: $user_action_key
				content_edited: $content_edited
			}
		) {
			key
		}
	}
`;
